(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6628],{

/***/ 88302:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'wrench';
var width = 512;
var height = 512;
var aliases = [128295];
var unicode = 'f0ad';
var svgPathData = 'M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.kl = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 77859:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fad';
var iconName = 'hand-holding-dollar';
var width = 576;
var height = 512;
var aliases = ["hand-holding-usd"];
var unicode = 'f4c0';
var svgPathData = ['M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z', 'M288 0c13.3 0 24 10.7 24 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandHoldingDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 64951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(77859);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.oF = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 92633:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'seedling';
var width = 512;
var height = 512;
var aliases = [127793,"sprout"];
var unicode = 'f4d8';
var svgPathData = ['M237.7 146.6c25.1 30.7 42.1 68.3 48 109.4l2.3 0c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32L448 0C351.5 0 269.2 61 237.7 146.6z', 'M32 64C14.3 64 0 78.3 0 96C0 219.7 100.3 320 224 320l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-32C288 164.3 187.7 64 64 64L32 64z'];

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.YK = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 68481:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'shield-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f2f7';
var svgPathData = ['M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z', 'M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z'];

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ip = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 15073:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fad';
var iconName = 'users';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f0c0';
var svgPathData = ['M0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM64 80a80 80 0 1 0 160 0A80 80 0 1 0 64 80zM404.7 320c.2 0 .4 0 .7 0l213.3 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80z', 'M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0z'];

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.FV = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 98576:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-technician",
      function () {
        return __webpack_require__(91560);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ WhatToExpectSection; },
/* harmony export */   "v": function() { return /* binding */ ReasonWhyItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3210);
/* harmony import */ var _GraySection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18737);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faWrench__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88302);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68481);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faHandHoldingUsd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64951);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faSeedling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92633);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faUsers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15073);










var WhatToExpectSection = function() {
    // const item = {
    //   title: 'REPAIRS AROUND YOUR SCHEDULE',
    //   subheading:
    //     'Life’s busy. So why waste your time sitting at a shop? Our brake techs come to you and repair your brakes around your schedule.',
    //   icon: faWrench,
    // }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GraySection__WEBPACK_IMPORTED_MODULE_3__/* .GraySection */ .g, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: "What To Expect"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description",
                    children: "Our technicians are the backbone of our business and we treat all team members like family. When you join the NuBrakes team, you’ll be given the tools and support needed to succeed."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "Top Industry Pay",
                            icon: _fortawesome_pro_duotone_svg_icons_faHandHoldingUsd__WEBPACK_IMPORTED_MODULE_5__/* .faHandHoldingUsd */ .oF,
                            subheading: "Our pay plan puts the ball in your court! We offer a guaranteed base salary, but there is no limit on what you can earn! Almost all of our techs exceed their base pay in a matter of weeks."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "Opportunity for growth",
                            icon: _fortawesome_pro_duotone_svg_icons_faSeedling__WEBPACK_IMPORTED_MODULE_6__/* .faSeedling */ .YK,
                            subheading: "We’re a high-growth startup and we’re reinventing the brake repair industry. We believe in a hire-from-within mentality and a high-growth company means opportunity to move up in your career."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "A Sense Of Team & Belonging",
                            icon: _fortawesome_pro_duotone_svg_icons_faUsers__WEBPACK_IMPORTED_MODULE_7__/* .faUsers */ .FV,
                            subheading: "Team is core to NuBrakes. We all help each other & work as a team to serve our customers. Our goal is to provide you with the support and tools you need to be successful each and every day."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-2 gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "Top-NOTCH SERVICE VEHICLE & EQUIPMENT",
                            icon: _fortawesome_free_solid_svg_icons_faWrench__WEBPACK_IMPORTED_MODULE_8__/* .faWrench */ .kl,
                            subheading: "We’ll provide you with a brand new, 2020 Nissan NV200 company service vehicle and all of the tools/equipment you need to deliver a 5 star service."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReasonWhyItem, {
                            title: "OFFICE & CUSTOMER SUPPORT",
                            icon: _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_9__/* .faShieldCheck */ .ip,
                            subheading: "Our Customer Service and Dispatch team is here to back you up. We have a stellar staff handling the customer interaction so you can focus on the task at hand."
                        })
                    ]
                })
            ]
        })
    });
};
var ReasonWhyItem = function(param) {
    var title = param.title, subheading = param.subheading, icon = param.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-grow flex-col h-100 py-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                    size: "4x",
                    icon: icon,
                    color: "#ea3616"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        style: {
                            paddingTop: 20,
                            fontSize: 18,
                            fontWeight: 900
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "m-0 description",
                        children: subheading
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ YelpButton; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "Op": function() { return /* binding */ ViewAllCitiesButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export LearnMoreButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center bg-lime hover:bg-green-600 text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};
var LearnMoreButton = function(param) {
    var children = param.children;
    var baseClassName = "ml-1 inline-block justify-center bg-blue-900 text-white text-sm px-2 rounded";
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(baseClassName),
        children: children
    });
};
var ButtonOutline = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "opacity-50 cursor-not-allowed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: "".concat(className, " border-primary hover:text-white border inline-block justify-center bg-transparent hover:bg-primary text-primary py-2 text-lg font-semibold px-5 rounded ").concat(disabled ? disabledClassName : "")
    }, rest), {
        children: children
    }));
};
var YelpButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block w-full md:w-auto  border-gray-800 border justify-center bg-transparent hover:bg-gray-800 hover:text-white text-gray-800 py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};
var ViewAllCitiesButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block border-allCitiesGray border justify-center bg-transparent hover:bg-allCitiesGray hover:text-white text-allCitiesGray py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};


/***/ }),

/***/ 97257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ FeatureBySection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
;// CONCATENATED MODULE: ./public/img/nbc-logo@grayscale-1024x266.png
/* harmony default export */ var nbc_logo_grayscale_1024x266 = ({"src":"/_next/static/media/nbc-logo@grayscale-1024x266.716bc1c2.png","height":266,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEV7e3t/f39MaXE+Pj5JSUlgYGBpaWlBQUFtbW0S8iZ+AAAACXRSTlOkAgCXssAzM8IzDEHQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgZGLjYGVnYmRgZGJgYGFmYgQAAfYALur2UdUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/business-insider-logo.png
/* harmony default export */ var business_insider_logo = ({"src":"/_next/static/media/business-insider-logo.c580027e.png","height":417,"width":1608,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEVubm5vb29ubm5tbW2is7ZZAAAABHRSTlNFN1MVwjbX/AAAAAlwSFlzAAALEwAACxMBAJqcGAAAABRJREFUeJxjYGJgYARhBmZGMIMZAACVABH1GLcLAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/aftermarket-news-logo.png
/* harmony default export */ var aftermarket_news_logo = ({"src":"/_next/static/media/aftermarket-news-logo.758a4f11.png","height":417,"width":1608,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEVMTExDQ0N9fX11dXVCQkJBQUFISEhpaWmQkJCptCviAAAACXRSTlMDcVNpVUoxKSU5ZKc7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYGBlYWRkY2Bg4GBmYmZiZwAAAWQAKzWo2m0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/ratchet-wrench-logo@grayscale.png
/* harmony default export */ var ratchet_wrench_logo_grayscale = ({"src":"/_next/static/media/ratchet-wrench-logo@grayscale.dd903de4.png","height":130,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEV3d3d2dnZ3d3d2dnZ0dHQNJw2BAAAABXRSTlNuf12QLh7GRWEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BmYGRgYGZgYWBiZGBmZGRiAgAA0wAYqAGTeQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/components/FeatureBySection.tsx








var FeatureBySection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "max-w-full py-5 bg-white px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-2 text-center gap-4 md:grid-cols-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-2 md:col-span-1 mb-2 md:mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            fontSize: 28,
                            fontWeight: 700
                        },
                        children: "Featured By"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 160
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: nbc_logo_grayscale_1024x266,
                        alt: "NBC Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 140
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: business_insider_logo,
                        alt: "Business Insider Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 160
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: aftermarket_news_logo,
                        alt: "After Market Image Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 140
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: ratchet_wrench_logo_grayscale,
                        alt: "Ratchet + Wrench Logo"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 18737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ GraySection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var GraySection = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var baseClassName = "bg-gray-100";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, className)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 91560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ become_a_technician; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/FeatureBySection.tsx + 4 modules
var FeatureBySection = __webpack_require__(97257);
// EXTERNAL MODULE: ./src/components/BecomeATechnicianPage/WhatToExpectSection.tsx
var WhatToExpectSection = __webpack_require__(56018);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
;// CONCATENATED MODULE: ./src/components/BecomeATechnicianPage/ApplyNowSection.tsx




var ApplyNowSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        style: {
            backgroundColor: "#ea3616"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "text-center text-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-white",
                    children: "Interested? Apply Now."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "We’re growing fast — explore and apply for our open brake tech positions now."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://apply.workable.com/nubrakes",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            className: "px-12",
                            style: {
                                backgroundColor: "#861f0c"
                            },
                            children: "Apply Now"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/nubrakes-van-house-800-num@3x.jpg
/* harmony default export */ var nubrakes_van_house_800_num_3x = ({"src":"/_next/static/media/nubrakes-van-house-800-num@3x.2567745c.jpg","height":1712,"width":3009,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAACAQQDAQAAAAAAAAAAAAABAgADBBExBQYiYf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAxAv/aAAwDAQACEQMRAD8An0wDlL9bAvVogIS1VH9kbxrAGfkREn2A5Lb/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/BecomeTechnicianTitleSection.tsx






var BecomeTechnicianTitleSection = function(param) {
    var title = param.title, subheading = param.subheading, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "py-0 text-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center align-center",
            style: {
                height: "60vh",
                position: "relative",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: nubrakes_van_house_800_num_3x,
                    placeholder: "blur",
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "bottom center"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "overlay",
                    style: {
                        minHeight: "100%",
                        width: "100%",
                        position: "absolute",
                        zIndex: 1,
                        backgroundColor: "rgba(0,0,0,.75)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "title",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "subheading",
                                children: subheading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://apply.workable.com/nubrakes",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                    className: "px-8",
                                    children: buttonText
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/become-a-technician.tsx








var BecomeATechnicianPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        showGetQuote: false,
        title: "Become A Technician | Join The NuBrakes Team | NuBrakes Mobile Brake Repair",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Join NuBrakes as we redefine the brake repair industry. If you’re an experienced mechanic looking for competitive pay and a sense of freedom, apply to become a NuBrakes mobile brake tech today."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeTechnicianTitleSection, {
                title: "Join the NuBrakes Team",
                subheading: "NuBrakes is hiring full-time and part-time technicians",
                buttonText: "Apply Now"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureBySection/* FeatureBySection */.x, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatToExpectSection/* WhatToExpectSection */.u, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyNowSection, {})
        ]
    });
};
/* harmony default export */ var become_a_technician = (BecomeATechnicianPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2978,2932,9774,2888,179], function() { return __webpack_exec__(98576); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);